const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/utils/urlLocationCheck.ts';
export const securedLoginUrl = 'secured/login';

export function isSecuredLocationPath() {
    return location.toString().indexOf(securedLoginUrl) !== -1;
}

export function getRedirectUrl(iamToken?: string) {
    if (iamToken) {
        return `${window.location.origin}/register?invitationcode=${iamToken}&loginurl=${
            document?.querySelector('base')?.href
        }${securedLoginUrl}`;
    }
    return `${window.location.origin}/register?loginurl=${document?.querySelector('base')?.href}${securedLoginUrl}`;
}
